export default "__VITE_PUBLIC_ASSET__43647f80__"